import React, { useEffect, useState } from "react";
import JobPostItem from "./components/JobPostItem";

const JobSearch = () => {
    const [jobPosts, setJobPosts] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        fetch(`${dna.site_url}/wp-json/custom/v1/jobs`)
            .then((response) => response.json())
            .then((data) => setJobPosts(data))
            .catch((error) => console.error("Error fetching job posts:", error));
    }, []);

    const filteredJobs = jobPosts.filter((post) =>
        post.title.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div>
            <div className="careers__filters" role="region" aria-labelledby="filters-heading">
                <h5 id="filters-heading">CURRENT OPPORTUNITIES</h5>

                <input
                    type="text"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />

                <hr />
            </div>

            <ul className="careers__list" role="list" aria-label="Job results">
                {filteredJobs.length > 0 ? (
                    filteredJobs.map((post) => <JobPostItem key={post.id} post={post} />)
                ) : (
                    <li className="p">No job postings match your filters.</li>
                )}
            </ul>
        </div>
    );
};

export default JobSearch;
